const BASE_URL = import.meta.env.VITE_BASE_URL;
const BASE_URL_WS = `${BASE_URL}ws`;
const BASE_URL_NODE = import.meta.env.VITE_BASE_URL_NODE;
const VERSION = import.meta.env.VITE_VER;
import { Device } from '@capacitor/device';

const getHeaders = () => ({
  'Authorization': 'a172cb42e5f615df578e5ae5a25e3f99',
  'accestoken': '943a107e7e008f92809f6fadf70ffa3f',
  'Content-Type': 'application/json',
});


const handleResponse = async (response: Response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || `Error ${response.status}: ${response.statusText}`);
  }
  return data;
};

const handleError = (error: any) => {
  console.log("error", error);
  throw new Error(error.message || 'Error en el servidor');
};

export const ficharService = {
  async generateQr(aData: any | number) {
    try {
      const response = await fetch(`${BASE_URL_NODE}generateqr`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(aData),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
  async getDataEmployee(idEmployee: string | number) {
    try {
      const response = await fetch(`${BASE_URL_WS}/getEmpleyeeById/${idEmployee}`, {
        method: 'GET',
        // headers: getHeaders(),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getPeriods(idEmployee: string | number) {
    try {
      const response = await fetch(`${BASE_URL_WS}/getPeriods/${idEmployee}?apk=true`, {
        method: 'GET',
        // headers: getHeaders(),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getLastAction(aData: Record<string, any>) {
    try {
      const queryString = new URLSearchParams(aData).toString();
      const response = await fetch(`${BASE_URL_WS}/getLastAction?${queryString}`, {
        method: 'GET',
        // headers: getHeaders(),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  logoutForced() {
    localStorage.clear();
    window.location.href = '/';
  },

   async inserRecord(aData: Record<string, any>) {
    try {
      // Obtenemos la información del dispositivo
      const info = await Device.getInfo();

      const payload = { 
        ...aData, 
        version: VERSION, // Asegúrate que esta constante sea "2"
        so: info.platform
      };

      const response = await fetch(`${BASE_URL_WS}/setRecord`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // ...getHeaders(), // Descomenta si usas tokens
        },
        body: JSON.stringify(payload),
      });

      // 1. Convertimos la respuesta a JSON primero
      const result = await response.json().catch(() => ({}));
      if ((result.error && result.error.status === "ko") || !response.ok) {
        throw new Error(result.error.error || `Error del servidor: ${result.error.status}`);
      }

      // 3. Si todo está bien, retornamos el resultado (que contiene la 'response')
      return result;

    } catch (error) {
      // 4. Propagamos el error para que el componente muestre el Toast con el mensaje real
      return handleError({message:error});
    }
  },

  async inserSignature(aData: Record<string, any>) {
    try {
      const response = await fetch(`${BASE_URL_WS}/guardarfirma`, {
        method: 'POST',
        // headers: getHeaders(),
        body: JSON.stringify(aData),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateSO(aData: Record<string, any>) {
    try {
      const response = await fetch(`${BASE_URL_WS}/setSoApp`, {
        method: 'POST',
        // headers: getHeaders(),
        body: JSON.stringify(aData),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async updateApkId(aData: Record<string, any>) {
    try {
      const response = await fetch(`${BASE_URL_WS}/setIdApk`, {
        method: 'POST',
        // headers: getHeaders(),
        body: JSON.stringify(aData),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getCorrecciones(hash: string) {
    try {
      const response = await fetch(`${BASE_URL_WS}/getcorrecciones/${hash}`, {
        method: 'GET',
        // headers: getHeaders(),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async contestarCorreccion(aData: Record<string, any>) {
    try {
      const response = await fetch(`${BASE_URL_WS}/contestarcorreccion`, {
        method: 'POST',
        // headers: getHeaders(),
        body: JSON.stringify(aData),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getPendientes(hash: string) {
    try {
      const response = await fetch(`${BASE_URL_WS}/getpendientes/${hash}`, {
        method: 'GET',
        // headers: getHeaders(),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async getJornadaDia(hash: string, fecha: string) {
    try {
      const response = await fetch(`${BASE_URL_WS}/getjornadadia/${hash}?fecha=${fecha}`, {
        method: 'GET',
        // headers: getHeaders(),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  async crearCorreccion(aData: { hash: string; fecha: string }) {
    try {
      const response = await fetch(`${BASE_URL_WS}/crearcorreccion`, {
        method: 'POST',
        // headers: getHeaders(),
        body: JSON.stringify(aData),
      });
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};
